module.exports = __webpack_public_path__ + "static/img/img1.22ceb13d.jpg";